<template>

	<section>

		<div class="headline">
			<h3><slot name="headline" /></h3>
		</div>
		<ul :class="['image-grid', gridType]">
			<slot name="body" />
		</ul>

	</section>

</template>

<script>

	export default {
		name: "ImageGrid",
		props: {
			gridType: String
		}
	}

</script>

<style lang="scss" scoped>

	@import "media.scss";
	@import "list-style-reset.scss";
	@import "responsive-font";

	.headline {
		padding:0 5vw; margin-bottom:3rem;
		@include media(large) {
			padding:0 7.5rem;
		}
		h3 {
			@include responsive-font(40);
			line-height:1.25; font-weight:400; color:#3D3D3D; text-transform:uppercase;
			@include media(small, large) {
				@include responsive-font(35);
			}
		}
	}

	.image-grid {
		@include list-style-reset;
		@include responsive-font(16);
		display:flex; flex-wrap:wrap; width:100%; color:#ffffff; line-height:1.66;
		li {
			background:#3D3D3D; flex-basis:50%; min-height:30vw; background-position:center; background-size:cover; position:relative; border:.5px solid #ffffff;
			@include media(large) {
				flex-basis:25%; min-height:20vw;
			}
		}
		h5 {
			@include responsive-font(30);
			line-height:1.25; font-weight:400; text-transform:uppercase; margin-bottom:.3rem; margin-top:1rem;
		}
		a {
			opacity:0; text-decoration:none; color:inherit; display:block; padding-left:2rem; padding-bottom:2.5rem; display:flex; flex-direction:column; justify-content:flex-end; height:100%; background-color:rgba(#FDB913, .9); transition:opacity .3s;
		}
		li:hover a {
			opacity:1;
		}
		p {
			margin: 0 1rem 0 0;
			line-height: 2.5rem;
			font-weight: 600;
			@include media(small, large) {
				display:none;
			}
		}
		&.three-column {
			li {
				flex-basis:100%; flex-basis:50%; min-height:50vw;
				@include media(xlarge) {
					flex-basis:33.333%; min-height:35vw;
				}
				a {
					justify-content:flex-start; padding:4.5rem 3.1rem 1rem 4.1rem;
					@include media(small, xlarge) {
						padding-left:5vw; padding-right:5vw;
					}
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/OurCompany/ImageGrid.vue